export function initNavBannerEu(bannerEU) {
  const banner = new BannerEu(bannerEU);
  banner.init();
}

class BannerEu {
  constructor(bannerEU) {
    this.banner = bannerEU;
  }

  init() {
    console.log(this._getCookieHideBannerEU());
    if (!this._getCookieHideBannerEU()) {
      this.banner?.classList.remove("is-hidden");
    }

    this.banner.querySelector(".js-close")?.addEventListener("click", e => {
      this.banner.classList.add("is-hidden");
      this._setCookieHideBannerEU();
    });
  }

  _getCookieHideBannerEU() {
    return document.cookie.split("; ").find(row => row.startsWith(`hideBannerEU=`))?.split("=")[1]
  }

  _setCookieHideBannerEU() {
    const expirationDate = new Date();
    // expires in 1 week
    expirationDate.setDate(expirationDate.getDate() + 7);
    // [dev only] expiration in 10 seconds
    //expirationDate.setTime(expirationDate.getTime()+(10*1000));
    const expirationDateString = expirationDate.toUTCString();
  
    document.cookie = `hideBannerEU=true; expires=${expirationDateString}; path=/`;
    console.log(`hideBannerEU=true; expires=${expirationDateString}; path=/`);
  }
}